import React from 'react';
import { motion } from 'framer-motion';
interface ProgressRingProps {
  progress: number; // 0 to 100
  size?: number;
  strokeWidth?: number;
  color?: string;
}
export function ProgressRing({
  progress,
  size = 60,
  strokeWidth = 6,
  color = 'text-indigo-600'
}: ProgressRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - progress / 100 * circumference;
  return <div className="relative flex items-center justify-center" style={{
    width: size,
    height: size
  }} data-id="element-1035">
      <svg className="transform -rotate-90" width={size} height={size} data-id="element-1036">
        <circle className="text-slate-100" strokeWidth={strokeWidth} stroke="currentColor" fill="transparent" r={radius} cx={size / 2} cy={size / 2} data-id="element-1037" />
        <motion.circle className={color} strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={circumference} animate={{
        strokeDashoffset: offset
      }} transition={{
        type: 'spring',
        stiffness: 50,
        damping: 20,
        duration: 1.5
      }} strokeLinecap="round" stroke="currentColor" fill="transparent" r={radius} cx={size / 2} cy={size / 2} data-id="element-1038" />
      </svg>
      <motion.div initial={{
      opacity: 0,
      scale: 0
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.5,
      type: 'spring'
    }} className="absolute text-xs font-bold text-slate-700" data-id="element-1039">
        {Math.round(progress)}%
      </motion.div>
    </div>;
}